
export const bannerSeriesMap = {
  "dragon-ball-banner": ["Dragon Ball"],
  "one-piece-banner": ["One Piece"],
  "dragon-ball-one-piece-banner": ["Dragon Ball", "One Piece"],
  "jujutsu-kaisen-demon-slayer-banner": ["Jujutsu Kaisen", "Demon Slayer"],
  "one-punch-man-my-hero-academia-banner": ["One Punch Man", "My Hero Academia"],
  "naruto-banner": ["Naruto"],
  "all-characters-mystery-banner": [], 
  "Premium-banner": []
};

